import axios from "axios";
import {ILead} from "../../../pages/leads-management/models/ILead";
import {makeRequest} from "../../../utils/helpers/helperMethods/makeRequest";
import { GetLeadByTypeRequest, GetLeadCount, GetLeadsRequest, GetSingleLeadRequest, Note, NoteEdit, UpdateLeadRequest } from "../types";

export async function CreateLead( lead:ILead,accessToken:any,  url:string) {
    try {
        const response = await  ( await  makeRequest(accessToken, url, 'POST',lead, ''));
        if (response.ok){
            return response.json();
        }else {
            throw new Error("Lead create failed");
        }
    }catch (e) {
        throw new Error("Lead create failed");
    }
}

export async function CreateNote(note: Note, accessToken:any,  url:string) {
    try {
        const response = await  ( await  makeRequest(accessToken, url, 'POST', note, ''));
        if (response.ok){
            return response.json();
        }else {
            throw new Error("Note create failed");
        }
    }catch (e) {
        throw new Error("Note create failed");
    }
}

export async function EditNote(note: NoteEdit, accessToken:any,  url:string) {
    try {
        const response = await  ( await  makeRequest(accessToken, url, 'PUT', note, ''));
        if (response.ok){
            return {message:'Note Updated', success:true};
        }else {
            throw new Error("Note edit failed");
        }
    }catch (e) {
        throw new Error("Note edit failed");
    }
}

export async function DeleteLead( id:string, accessToken:any,  url:string) {
    try {
        const response = await  ( await  makeRequest(accessToken, url, 'DELETE',id, ''));
        if (response.ok){
            return {message:'Lead Deleted', success:true};
        }else {
            throw new Error("Lead delete failed");
        }
    }catch (e) {
        throw new Error("Lead delete failed");
    }
}


export async function DeleteNote( id:number, accessToken:any,  url:string) {
    try {
        const response = await  ( await  makeRequest(accessToken, url, 'DELETE',id, ''));
        if (response.ok){
            return {message:'Note Deleted', success:true};
        }else {
            throw new Error("Note delete failed");
        }
    }catch (e) {
        throw new Error("Note delete failed");
    }
}



export async function getLeads(pageNumber:number,pageSize:number, searchText:string, orderBy:string,isAscSorting:boolean,userRole:string , version:string , token :string, rating:string) {
    try{
        return await axios.get(`${process.env.REACT_APP_INFINITYS_API}/api/${version}/Lead/PaginateList?PageNumber=${pageNumber}&PageSize=${pageSize}&SearchText=${searchText}&OrderBy=${orderBy}&isAscSorting=${isAscSorting}&UserRole=${userRole}&rating=${rating}`, {
            headers:{
                "Authorization" : token
            }
        })
    }catch (e) {
        throw "Leads get failed"
    }
}

export async function getAllLeadDetails(
    {OrderBy,PageNumber,PageSize,ParameterOne,ParameterThree,ParameterTwo, SearchText,SortOrder,accessToken,url}: GetLeadsRequest
) {
    try {
        const endpoint = `${url}/leads?PageSize=${PageSize}&PageNumber=${PageNumber}&SearchText=${SearchText}`;
        const response = await  ( await  makeRequest(accessToken, endpoint, 'GET', null, ''));
        if (response.ok){
            return await response.json();
        }else {
            throw new Error("Leads get Failed");
        }
    } catch (e) {
        throw new Error("Leads get Failed");
    }
}

export async function getLeadDetails(
   {PageNumber,PageSize,SearchText,accessToken,url,leadType}: GetLeadByTypeRequest
) {
    try {
        const endpoint = `${url}/leads?PageSize=${PageSize}&PageNumber=${PageNumber}&SearchText=${SearchText}&ParameterOne=${leadType}`;
        const response = await  ( await  makeRequest(accessToken, endpoint, 'GET', null, ''));
        if (response.ok){
            return await response.json();
        }else {
            throw new Error("Leads get Failed");
        }
    } catch (e) {
        throw new Error("Leads get Failed");
    }
}


export async function getSingleLead( {accessToken,id,url}: GetSingleLeadRequest) {
    try {
        const endpoint = `${url}/leads/${id}`;
        const response = await  ( await  makeRequest(accessToken, endpoint, 'GET', null, ''));
        if (response.ok){
            return await response.json();
        }else {
            throw new Error("Leads get Failed");
        }
    } catch (e) {
        throw new Error("Leads get Failed");
    }
}

export async function updateLeadAction( {accessToken,action,id,url}: UpdateLeadRequest) {
    try {
        const endpoint = `${url}/leads/${id}/${action}`;
        const response = await  ( await  makeRequest(accessToken, endpoint, 'PATCH', null, ''));
        if (response.ok){
            return {message: 'Lead patch success', success: true};
        }else {
            throw new Error("Leads action update failed");
        }
    } catch (e) {
        throw new Error("Leads action update failed");
    }
}


export async function getLatLongFromAddress(address:string) {
    const apiKey = process.env.REACT_APP_GOOGLE_API_KEY;
    const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${apiKey}`;
    return await fetch(apiUrl)
        .then(response => response.json())
        .then(data => {
            if (data.status === 'OK' && data.results.length > 0) {
                const location = data.results[0].geometry.location;
                return { lat: location.lat, lng: location.lng };
            } else {
                throw new Error('Unable to retrieve location information');
            }
        })
        .catch(error => {
            console.error('Error:', error);
        });
}

export async function downloadLeads(
    ParameterOne: string,
    url: string,
    accessToken: string,
) {
    try {
        const endpoint = `${url}/leads/download?ParameterOne=${ParameterOne}`;
        const response = await  ( await  makeRequest(accessToken, endpoint, 'GET', null, ''));
        if (response.ok){
            const blob = await response.blob();
            const downloadLink = window.URL.createObjectURL(blob);
            const download = document.createElement('a');
            download.href = downloadLink;
            download.download = 'Leads.csv';
            document.body.appendChild(download);
            download.click();
            document.body.removeChild(download);
        }else {
            throw new Error("Leads download Failed");
        }
    } catch (e) {
        throw new Error("Leads download Failed");
    }
}

export async function downloadSelectedLeads(
    LeadIds: number[],
    url: string,
    accessToken: string,
) {
    try {
        const endpoint = `${url}/leads/downloadSelectedLeads`;
        const response = await makeRequest(accessToken, endpoint, 'POST', LeadIds, '');
        if (response.ok){
            const blob = await response.blob();
            const downloadLink = window.URL.createObjectURL(blob);
            const download = document.createElement('a');
            download.href = downloadLink;
            download.download = 'Leads.csv';
            document.body.appendChild(download);
            download.click();
            document.body.removeChild(download);
        }else {
            throw new Error("Leads download Failed");
        }
    } catch (e) {
        throw new Error("Leads download Failed");
    }
}

export async function getLeadCount( {accessToken,type,url}: GetLeadCount) {
    try {
        const endpoint = `${url}/leads/recent/8/${type}`;
        const response = await  ( await  makeRequest(accessToken, endpoint, 'GET', null, ''));
        if (response.ok){
            return await response.json();
        }else {
            throw new Error("Count get Failed");
        }
    } catch (e) {
        throw new Error("Count get Failed");
    }
}
